// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { SystemsIntegrationsQueries } from '../../../../types/server/modules/systemsIntegrations/queries';

export type * from '../../../../types/server/modules/systemsIntegrations/queries';

export const createQueries = ( requests: Requests ): SystemsIntegrationsQueries => ({
  SystemsIntegrationsConnectorsById: ( id, query, headers ) => { 
          return requests.get( `/systems-integrations-connectors/${id}`, query, headers ); 
        },
  SystemsIntegrationsConnectors: ( params?, headers? ) => {
        return requests.get( `/systems-integrations-connectors/:id?`, params, headers );
      },
  ReadExternalSystems: ( params?, headers? ) => {
        return requests.get( `/read-external-systems`, params, headers );
      },
  ExternalSystemsIntegrationsById: ( id, query, headers ) => { 
          return requests.get( `/external-systems-integrations/${id}`, query, headers ); 
        },
  ExternalSystemsIntegrations: ( params?, headers? ) => {
        return requests.get( `/external-systems-integrations/:id?`, params, headers );
      },
  ExternalLogisticsIntegrationsById: ( id, query, headers ) => { 
          return requests.get( `/external-logistics-integrations/${id}`, query, headers ); 
        },
  ExternalLogisticsIntegrations: ( params?, headers? ) => {
        return requests.get( `/external-logistics-integrations/:id?`, params, headers );
      },
  SystemsIntegrationsErpSyncMirrorSearch: ( params?, headers? ) => {
        return requests.get( `/systems-integrations/erp-sync-mirror-search/:search?`, params, headers );
      },
  SystemsIntegrationsErpSyncMirrorById: ( id, query, headers ) => { 
          return requests.get( `/systems-integrations/erp-sync-mirror/${id}`, query, headers ); 
        },
  SystemsIntegrationsErpSyncMirror: ( params?, headers? ) => {
        return requests.get( `/systems-integrations/erp-sync-mirror/:id?`, params, headers );
      },
  SystemsIntegrationsErpDriftEpisodesSearch: ( params?, headers? ) => {
        return requests.get( `/systems-integrations/erp-drift-episodes-search/:search?`, params, headers );
      },
  SystemsIntegrationsErpDriftEpisodesById: ( id, query, headers ) => { 
          return requests.get( `/systems-integrations/erp-drift-episodes/${id}`, query, headers ); 
        },
  SystemsIntegrationsErpDriftEpisodes: ( params?, headers? ) => {
        return requests.get( `/systems-integrations/erp-drift-episodes/:id?`, params, headers );
      },
  SystemsIntegrationsAccountEmailsById: ( id, query, headers ) => { 
          return requests.get( `/systems-integrations/account-emails/${id}`, query, headers ); 
        },
  SystemsIntegrationsAccountEmails: ( params?, headers? ) => {
        return requests.get( `/systems-integrations/account-emails/:id?`, params, headers );
      },
  SystemsIntegrationsChannelCategories: ( params?, headers? ) => {
        return requests.get( `/systems-integrations/channel-categories/:integrationId?`, params, headers );
      },
  SystemsIntegrationsChannelCategoriesSearch: ( params?, headers? ) => {
        return requests.get( `/systems-integrations/channel-categories-search/:integrationId?`, params, headers );
      }
});
